/*!
 * Performance Observer Polyfill
 * Version: 1.1.1
 * https://github.com/fastly/performance-observer-polyfill
 * 
 * Copyright (c) 2020, Fastly, Inc. All rights reserved.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.PerformanceOberserverPolyfill = t() : e.PerformanceOberserverPolyfill = t();
}(this, function () {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        r.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    function n(e) {
      return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function o(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, r = new Array(e.length); t < e.length; t++) {
            r[t] = e[t];
          }
          return r;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }
    function i(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function u(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function s(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (s = function s(e) {
        if (null === e || (r = e, -1 === Function.toString.call(r).indexOf("[native code]"))) return e;
        var r;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, n);
        }
        function n() {
          return c(e, arguments, f(this).constructor);
        }
        return n.prototype = Object.create(e.prototype, {
          constructor: {
            value: n,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), a(n, e);
      })(e);
    }
    function c(e, t, r) {
      return (c = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }() ? Reflect.construct : function (e, t, r) {
        var n = [null];
        n.push.apply(n, t);
        var o = new (Function.bind.apply(e, n))();
        return r && a(o, r.prototype), o;
      }).apply(null, arguments);
    }
    function a(e, t) {
      return (a = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function f(e) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    r.r(t);
    var l = function (e) {
      function t(e) {
        var r, i, s, c, a;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), i = function (e, t) {
          return !t || "object" !== n(t) && "function" != typeof t ? u(e) : t;
        }(this, (r = f(t)).call.apply(r, [this].concat(o(e)))), s = u(i), a = void 0, (c = "_entries") in s ? Object.defineProperty(s, c, {
          value: a,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : s[c] = a, i._entries = e, i;
      }
      var r, s, c;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && a(e, t);
      }(t, e), r = t, (s = [{
        key: "getEntries",
        value: function value() {
          return this._entries;
        }
      }, {
        key: "getEntriesByType",
        value: function value(e) {
          return this._entries.filter(function (t) {
            return t.entryType === e;
          });
        }
      }, {
        key: "getEntriesByName",
        value: function value(e, t) {
          return this._entries.filter(function (t) {
            return t.name === e;
          }).filter(function (e) {
            return !t || e.entryType === t;
          });
        }
      }]) && i(r.prototype, s), c && i(r, c), t;
    }(s(Array));
    function y(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function p(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function v(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function b(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var d = ["mark", "measure", "navigation", "resource"],
      h = "Failed to execute 'observe' on 'PerformanceObserver': either an 'entryTypes' or 'type' member must be present.",
      m = "Failed to execute 'observe' on 'PerformanceObserver': either an 'entryTypes' or 'type' member must be present, not both.",
      g = "Aborting 'observe' on 'PerformanceObserver': no valid entry types present in either 'entryTypes' or 'type' member.",
      O = "Invalid or unsupported entry types provided to 'observe' on 'PerformanceObserver'.",
      w = function w(e) {
        return d.some(function (t) {
          return e === t;
        });
      },
      P = new (function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = t.registeredObservers,
            n = void 0 === r ? new Set() : r,
            o = t.processedEntries,
            i = void 0 === o ? new Set() : o,
            u = t.interval,
            s = void 0 === u ? 100 : u,
            c = t.context,
            a = void 0 === c ? self : c;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), p(this, "registeredObservers", void 0), p(this, "processedEntries", void 0), p(this, "interval", void 0), p(this, "intervalId", void 0), p(this, "context", void 0), this.registeredObservers = n, this.processedEntries = i, this.interval = s, this.context = a, this.intervalId = null;
        }
        var t, r, n;
        return t = e, (r = [{
          key: "getNewEntries",
          value: function value() {
            var e = this;
            return this.context.performance.getEntries().filter(function (t) {
              return !e.processedEntries.has(t);
            });
          }
        }, {
          key: "getObserversForType",
          value: function value(e, t) {
            return Array.from(e).filter(function (e) {
              return e.entryTypes.some(function (e) {
                return e === t;
              });
            });
          }
        }, {
          key: "processBuffer",
          value: function value(e) {
            var t = Array.from(e.buffer),
              r = new l(t);
            e.buffer.clear(), t.length && e.callback && e.callback.call(void 0, r, e);
          }
        }, {
          key: "processEntries",
          value: function value() {
            var e = this;
            this.getNewEntries().forEach(function (t) {
              var r = t.entryType;
              e.getObserversForType(e.registeredObservers, r).forEach(function (e) {
                e.buffer.add(t);
              }), e.processedEntries.add(t);
            });
            var t = function t() {
              return e.registeredObservers.forEach(e.processBuffer);
            };
            "requestAnimationFrame" in this.context ? this.context.requestAnimationFrame(t) : this.context.setTimeout(t, 0);
          }
        }, {
          key: "add",
          value: function value(e) {
            this.registeredObservers.add(e), 1 === this.registeredObservers.size && this.observe();
          }
        }, {
          key: "remove",
          value: function value(e) {
            this.registeredObservers.delete(e), this.registeredObservers.size || this.disconnect();
          }
        }, {
          key: "observe",
          value: function value() {
            this.intervalId = this.context.setInterval(this.processEntries.bind(this), this.interval);
          }
        }, {
          key: "disconnect",
          value: function value() {
            this.intervalId = this.context.clearInterval(this.intervalId);
          }
        }]) && y(t.prototype, r), n && y(t, n), e;
      }())(),
      k = function () {
        function e(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : P;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), b(this, "callback", void 0), b(this, "buffer", void 0), b(this, "entryTypes", []), b(this, "taskQueue", void 0), this.callback = t, this.buffer = new Set(), this.taskQueue = r;
        }
        var t, r, n;
        return t = e, (r = [{
          key: "observe",
          value: function value(e) {
            if (!e) throw new Error(h);
            if (e.entryTypes && e.type) throw new Error(m);
            var t;
            if (e.entryTypes) t = e.entryTypes;else {
              if (!e.type) throw new Error(h);
              t = [e.type];
            }
            var r = t.filter(w);
            r.length > 0 && r.length !== t.length && console.warn(O), r.length ? (this.entryTypes = r, this.taskQueue.add(this)) : console.warn(g);
          }
        }, {
          key: "disconnect",
          value: function value() {
            this.taskQueue.remove(this);
          }
        }, {
          key: "takeRecords",
          value: function value() {
            var e = Array.from(this.buffer);
            return new l(e);
          }
        }]) && v(t.prototype, r), n && v(t, n), e;
      }();
    b(k, "supportedEntryTypes", d);
    var E = "PerformanceObserver" in self && "function" == typeof PerformanceObserver ? PerformanceObserver : k,
      j = self;
    j.PerformanceObserver || (j.PerformanceObserver = E);
  }]);
});